<template>
    <div class="custom-panel">
        <div class="row row-panel-buttons">

            <div class="col-md-8" style="display: flex; justify-content:space-between;">
                <div class="col-md-1"
                    style="width:calc( min(max(42px, calc(7vw)), 52px));; height: calc( min(max(42px, calc(7vh)), 52px)); margin-right: 1%; ">
                    <button class="btn-panel-sgv-filter" @click="showModalFiltro()">
                        <svg width="16" height="16" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M24.0001 12V1.90735e-05H28.0313V4.03127H36.0001V7.96877H28.0313V12H24.0001ZM36.0001 19.9688H16.0313V16.0313H36.0001V19.9688ZM7.96881 12H12.0001V24H7.96881V19.9688H6.10352e-05V16.0313H7.96881V12ZM19.9688 36H16.0313V24H19.9688V28.0313H36.0001V31.9688H19.9688V36ZM6.10352e-05 4.03127H19.9688V7.96877H6.10352e-05V4.03127ZM6.10352e-05 28.0313H12.0001V31.9688H6.10352e-05V28.0313Z"
                                fill="#ffffff" />
                        </svg>
                    </button>
                </div>
                <!-- <div class="col-md-2" style="margin-top: 10px"> -->
                <div class="col-md-1 " style="width: calc( min(max(100px, calc(11vw)), 219px));; margin-right: 1%;">
                    <select name="" id="line_group" class="form-control form-select form-panel form-panel"
                        @change="selectedFilter($event, 'group')" v-model="selectedGroup">
                        <option value="null" selected>Grupo de Linhas</option>
                        <option v-for="groupline in grouplines" v-bind:key="groupline.id" :value="groupline.id">{{
                            groupline.alias }}</option>
                    </select>
                </div>
                <div class="col-md-1 " style="width: calc( min(max(100px, calc(8vw)), 159px)); margin-right: 1%;">
                    <select name="" id="terminal" class="form-control form-select form-panel"
                        @change="selectedFilter($event, 'terminal')" v-model="selectedTerminal">
                        <option value="null" selected>Terminal</option>
                        <option v-for="terminal in terminals" v-bind:key="terminal.id" :value="terminal.id">{{
                            terminal.alias }}
                        </option>
                    </select>
                </div>
                <div class="col-md-1" style="width: calc( min(max(100px, calc(7vw)), 120px)); margin-right: 1%;">
                    <select name="" id="line" class="form-control form-select form-panel"
                        @change="selectedFilter($event, 'line')" v-model="selectedLine">
                        <option value="null" selected>Linha</option>
                        <option v-for="line in lines" v-bind:key="line.id" :value="line.id">{{ line.alias }}</option>
                    </select>
                </div>
                <div class="col-md-1" style="width: calc( min(max(100px, calc(8vw)), 130px)); margin-right: 1%;">
                    <select name="" id="sense" class="form-control form-select form-panel"
                        @change="selectedFilter($event, 'sense')" v-model="selectedSense">
                        <option value="null" selected>Sentido</option>
                        <option v-for="sense in senses" v-bind:key="sense.id" :value="sense.id">{{ sense.alias }}</option>
                    </select>
                </div>
                <div class="col-md-1" style="width:calc( min(max(100px, calc(8vw)), 130px)); margin-right: 1%;">
                    <select name="" id="position" class="form-control form-select form-panel"
                        @change="selectedFilter($event, 'position')" v-model="selectedPosition">
                        <option value="null" selected>Posição</option>
                        <option v-for="position in positions" v-bind:key="position.id" :value="position.id">{{
                            position.alias }}
                        </option>
                    </select>
                </div>
                <div class="col-md-1" style="width:calc( min(max(100px, calc(6vw)), 130px)); margin-right: 1%;">
                    <select name="" id="vehicle" class="form-control form-select form-panel"
                        @change="selectedFilter($event, 'vehicle')" v-model="selectedVehicle">
                        <option value="null" selected>Veículo</option>
                        <option v-for="vehicle in vehicles" v-bind:key="vehicle.id" :value="vehicle.id">{{ vehicle.alias }}
                        </option>
                    </select>
                </div>
            </div>

            <!-- <div class="col-md-3" > -->
            <!-- <div style="border: 1px solid black; display: inline-block;"> -->
            <div class="col-md-4 " style="display: flex; justify-content:flex-end; ">
                <!-- <a class="btn-panel-question">
                    <i class="fa fa-question-circle-o" style="font-size:40px"></i>
                </a> -->
                <div class="col-md-1"
                    style="width:calc( min(max(42px, calc(7vw)), 52px));; height: calc( min(max(42px, calc(7vh)), 52px)); margin-right: 1%;">
                    <button class="btn-panel-sgv-filter" @click="showModalFiltroLinhas()">
                        <svg width="16" height="16" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M1.53125 4.25C2.34375 5.25 3.25 6.40625 4.25 7.71875C5.25 9.03125 6.25 10.3438 7.25 11.6562C8.3125 12.9688 9.25 14.1875 10.0625 15.3125C10.9375 16.4375 11.625 17.3438 12.125 18.0312C12.6875 18.6562 12.9688 18.9688 12.9688 18.9688V30.9688C12.9688 31.5312 13.1562 32.0312 13.5312 32.4688C13.9688 32.8438 14.4688 33.0312 15.0312 33.0312H18.9688C19.5312 33.0312 20 32.8438 20.375 32.4688C20.8125 32.0312 21.0312 31.5312 21.0312 30.9688V18.9688C21.0312 18.9688 21.2812 18.6562 21.7812 18.0312C22.3438 17.3438 23.0312 16.4375 23.8438 15.3125C24.7188 14.1875 25.6562 12.9688 26.6562 11.6562C27.7188 10.3438 28.75 9.03125 29.75 7.71875C30.75 6.40625 31.6562 5.25 32.4688 4.25C32.8438 3.8125 33 3.34375 32.9375 2.84375C32.875 2.34375 32.6562 1.90625 32.2812 1.53125C31.9062 1.15625 31.4375 0.96875 30.875 0.96875H3.125C2.5625 0.96875 2.09375 1.15625 1.71875 1.53125C1.34375 1.90625 1.125 2.34375 1.0625 2.84375C1 3.34375 1.15625 3.8125 1.53125 4.25Z"
                                fill="#E4EBF3" />
                        </svg>
                    </button>
                </div>
                <div class="col-md-1"
                    style="width:calc( min(max(42px, calc(7vw)), 52px));; height: calc( min(max(42px, calc(7vh)), 52px)); margin-right: 1%;">
                    <button class="btn-panel-sgv-add" @click="showModalIncluirViagem(trip)">
                        <svg width="16" height="16" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M30.0312 21.9688V18.0312H21.9688V9.96875H18.0312V18.0312H9.96875V21.9688H18.0312V30.0312H21.9688V21.9688H30.0312ZM5.84375 5.9375C9.78125 2 14.5 0.03125 20 0.03125C25.5 0.03125 30.1875 2 34.0625 5.9375C38 9.8125 39.9688 14.5 39.9688 20C39.9688 25.5 38 30.2188 34.0625 34.1562C30.1875 38.0312 25.5 39.9688 20 39.9688C14.5 39.9688 9.78125 38.0312 5.84375 34.1562C1.96875 30.2188 0.03125 25.5 0.03125 20C0.03125 14.5 1.96875 9.8125 5.84375 5.9375Z"
                                fill="#E4EBF3" />
                        </svg>
                    </button>
                </div>
                <div class="col-md-1"
                    style="width:calc( min(max(42px, calc(7vw)), 52px));; height: calc( min(max(42px, calc(7vh)), 52px)); margin-right: 1%;">
                    <button class="btn-panel-sgv-edit" @click="showModalNovaEscala()">
                        <svg width="16" height="16" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M35.4375 8.0625L31.7812 11.7188L24.2812 4.21875L27.9375 0.5625C28.3125 0.1875 28.7812 0 29.3438 0C29.9062 0 30.375 0.1875 30.75 0.5625L35.4375 5.25C35.8125 5.625 36 6.09375 36 6.65625C36 7.21875 35.8125 7.6875 35.4375 8.0625ZM0 28.5L22.125 6.375L29.625 13.875L7.5 36H0V28.5Z"
                                fill="#E4EBF3" />
                        </svg>
                    </button>
                </div>
            </div>
            <!-- </div> -->
        </div>

        <br>
        <div class="col-md-12 shadow-light table-custom">
            <!-- <div class="table-responsive" style="margin-top: 0px; "> -->
            <div class="table-responsive">
                <table class="table align-middle bordered">
                    <thead class="table-head shadow-table-top  font-responsive">
                        <tr class="trpanel">
                            <th class="text-font" data-column="col1">TERMINAL</th>
                            <th class="text-font" data-column="col2">LINHA</th>
                            <th class="text-font" data-column="col3">VIAGEM</th>
                            <th class="text-font" data-column="col4">TIPO</th>

                            <th class="text-font" data-column="col5">POSIÇÃO</th>
                            <th class="text-font" data-column="col6">VEICULO PREV.</th>
                            <th class="text-font" data-column="col7">VEICULO REAL</th>
                            <th class="text-font" data-column="col8">MOTORISTA PREV.</th>

                            <th class="text-font" data-column="col9">MOTORISTA REAL</th>
                            <th class="text-font" data-column="col10">COBRADOR PREV.</th>
                            <th class="text-font" data-column="col11">COBRADOR REAL</th>
                            <th class="text-font" data-column="col12">SENTIDO</th>

                            <th class="text-font" data-column="col13">INÍCIO. PREV.</th>
                            <th class="text-font" data-column="col14">INÍCIO. REAL.</th>
                            <th class="text-font" data-column="col15">FIM. PREV.</th>
                            <th class="text-font" data-column="col16">FIM. REAL.</th>

                            <th class="text-font" data-column="col17">TEMPO DE VIAG PREVISTA</th>
                            <th class="text-font" data-column="col18">TEMPO DE VIAG REALIZADA</th>
                            <th class="text-font" data-column="col19">PROGRESSO</th>
                            <th class="text-font" data-column="col20">VNR</th>
                        </tr>
                    </thead>
                    <tbody class="font-responsive">
                        <!-- :class="trip.class != null ? trip.class : 'default'">        -->
                        <tr class="trpanel"  v-for="trip in trips" :key="trip.item_id" :id="trip.item_id"
                            @click="getIdItem(trip.item_id)" :class="trip.vnr == null ? trip.class : 'vnr'">
                            <td class="text-font" data-column="col1" >{{ trip.start_point_name }}</td>
                            <td class="text-font" data-column="col2" >{{ trip.line_code }}</td>
                            <td class="text-font" data-column="col3" >{{ trip.number_trip }}</td>
                            <td class="text-font" data-column="col4" >{{ trip.type_trip }}</td>

                            <td class="text-font" data-column="col5">{{ trip.position }}</td>
                            <td class="text-font" data-column="col6">{{ trip.old_asset_id }}</td>
                            <td class="text-font" data-column="col7" style="position: relative;">
                                <!-- <svg width="19" height="12" viewBox="0 0 24 17" fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                    style="position: absolute; left: 0; top: 50%; transform: translateY(-50%);">
                                    <path
                                        d="M5.01562 8.98438C6.95312 7.07813 9.28125 6.125 12 6.125C14.75 6.125 17.0781 7.07813 18.9844 8.98438L17.0156 11C16.4531 10.4375 15.6719 9.95313 14.6719 9.54688C13.7031 9.14063 12.8125 8.9375 12 8.9375C11.1875 8.9375 10.2812 9.14063 9.28125 9.54688C8.3125 9.95313 7.54687 10.4375 6.98437 11L5.01562 8.98438ZM9 13.0156C9.84375 12.1719 10.8437 11.75 12 11.75C13.1562 11.75 14.1562 12.1719 15 13.0156L12 16.0156L9 13.0156ZM0.984375 5C4.04687 1.96875 7.71875 0.453125 12 0.453125C16.3125 0.453125 19.9844 1.96875 23.0156 5L21 7.01563C18.5 4.54688 15.5 3.3125 12 3.3125C8.5 3.3125 5.5 4.54688 3 7.01562L0.984375 5Z"
                                        :fill="colors[trip.online]" stroke="#000000" stroke-width="0.5" />
                                </svg> -->
                                <v-select :id="'asset' + trip.item_id" class="input-edit"
                                    v-model="change_list['input_asset_' + trip.item_id]" label="alias" :options="vehicles"
                                    @focusout="updateTrips(trip.item_id, 
                                    trip.planning_id, 
                                    trip.number_trip, 
                                    trip.position, 
                                    trip.data, 
                                    'asset', 
                                    trip.expected_time_start,
                                    trip.data, 
                                    trip.sense_name, 
                                    trip.line_id)"
                                    @click="changeClass(trip.item_id, 'asset')"
                                    style="margin-left: 25px; margin-right: 25px;">
                                </v-select>
                            </td>
                            <td class="text-font" data-column="col8">{{ trip.old_driver_id }}</td>
                            <td class="text-font" data-column="col9">

                                <v-select style="width: 60px; height: 20px" class="input-edit" label="alias"
                                    :options="drivers" :id="'driver' + trip.item_id"
                                    v-model="change_list['input_driver_' + trip.item_id]"
                                    @focusout="updateTrips(trip.item_id, 
                                    trip.planning_id, 
                                    trip.number_trip, 
                                    trip.position, 
                                    trip.data, 
                                    'driver', 
                                    trip.expected_time_start, 
                                    trip.data, 
                                    trip.sense_name, 
                                    trip.line_id)">
                                </v-select>
                            </td>
                            <td class="text-font" data-column="col10">{{ trip.old_cobrador_id }}</td>
                            <td class="text-font" data-column="col11">

                                <v-select style="width: 60px; height: 20px" class="input-edit" label="alias"
                                    :options="drivers.tipo != null ? (drivers.tipo != 'motorista' ? drivers : '') : ''"
                                    :id="'cobrador' + trip.item_id" v-model="change_list['input_cobrador_' + trip.item_id]"
                                    @focusout="updateTrips(trip.item_id, 
                                    trip.planning_id, 
                                    trip.number_trip, 
                                    trip.position, 
                                    trip.data, 
                                    'cobrador', 
                                    trip.expected_time_start, 
                                    trip.data, 
                                    trip.sense_name, 
                                    trip.line_id)">
                                </v-select>
                            </td>
                            <td class="text-font" data-column="col12">{{ trip.sense_name }}</td>

                            <td class="text-font" data-column="col13">{{ trip.expected_time_start }}</td>
                            <td class="text-font" data-column="col14">{{ trip.real_time_start }}</td>
                            <td class="text-font" data-column="col15">{{ trip.expected_time_end }}</td>
                            <td class="text-font" data-column="col16">{{ trip.real_time_end }}</td>

                            <td class="text-font" data-column="col17">{{ trip.expected_time_minute }}</td>
                            <td class="text-font" data-column="col18">{{ trip.real_time_minute }}</td>
                            <td class="text-font" data-column="col19">{{trip.progress}}
                                <!-- %
                                <div class="progress">
                                    <div class="progress-value" :style="{ '--width': trip.progress }"></div>
                                </div> -->
                            </td>
                            <td class="text-font" data-column="col20">

                                <!-- Default dropstart button -->
                                <div class="btn-group dropstart">
                                    <button type="button" class="btn btn-light dropdown-toggle custom-toggle" data-bs-toggle="dropdown" aria-expanded="false">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-three-dots-vertical" viewBox="0 0 16 16">
                                            <path d="M9.5 13a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0z"/>
                                        </svg>
                                    </button>
                                <ul class="dropdown-menu dropdown-menu-panel">
                                    <!-- Dropdown menu links -->
                                    <li :id="'button_vnr' + trip.item_id" class="custom-color-text-blue custom-list-painel" @click="showModalEvento(trip)">
                                        <span style="display: inline-block; padding: 5px;">VNR</span>
                                        <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M8.75 5.82422H9.92578V7H8.75V5.82422ZM8.75 2.32422H9.92578V5.25H8.75V2.32422ZM7.27344 6.72656C7.83854 7.29167 8.52214 7.57422 9.32422 7.57422C10.1263 7.57422 10.8099 7.29167 11.375 6.72656C11.9583 6.16146 12.25 5.47786 12.25 4.67578C12.25 3.8737 11.9583 3.1901 11.375 2.625C10.8099 2.04167 10.1263 1.75 9.32422 1.75C8.52214 1.75 7.83854 2.04167 7.27344 2.625C6.70833 3.1901 6.42578 3.8737 6.42578 4.67578C6.42578 5.47786 6.70833 6.16146 7.27344 6.72656ZM7.24609 10.8281C7.41016 10.9922 7.61979 11.0742 7.875 11.0742C8.13021 11.0742 8.33984 10.9922 8.50391 10.8281C8.66797 10.6458 8.75 10.4362 8.75 10.1992C8.75 9.96224 8.66797 9.76172 8.50391 9.59766C8.33984 9.41536 8.13021 9.32422 7.875 9.32422C7.61979 9.32422 7.41016 9.41536 7.24609 9.59766C7.08203 9.76172 7 9.96224 7 10.1992C7 10.4362 7.08203 10.6458 7.24609 10.8281ZM1.75 7.57422H6.48047C5.66016 6.79036 5.25 5.82422 5.25 4.67578H1.75V7.57422ZM1.99609 10.8281C2.16016 10.9922 2.36979 11.0742 2.625 11.0742C2.88021 11.0742 3.08984 10.9922 3.25391 10.8281C3.41797 10.6458 3.5 10.4362 3.5 10.1992C3.5 9.96224 3.41797 9.76172 3.25391 9.59766C3.08984 9.41536 2.88021 9.32422 2.625 9.32422C2.36979 9.32422 2.16016 9.41536 1.99609 9.59766C1.83203 9.76172 1.75 9.96224 1.75 10.1992C1.75 10.4362 1.83203 10.6458 1.99609 10.8281ZM9.32422 0.574219C10.4544 0.592448 11.4115 1.0026 12.1953 1.80469C12.9974 2.60677 13.3984 3.5638 13.3984 4.67578C13.3984 5.64193 13.0612 6.51693 12.3867 7.30078C11.7122 8.08464 10.8919 8.54948 9.92578 8.69531V10.5C9.92578 10.9922 9.72526 11.4206 9.32422 11.7852V12.8242C9.32422 12.9883 9.26953 13.1341 9.16016 13.2617C9.05078 13.3711 8.91406 13.4258 8.75 13.4258H8.17578C8.01172 13.4258 7.86589 13.3711 7.73828 13.2617C7.62891 13.1341 7.57422 12.9883 7.57422 12.8242V12.25H2.92578V12.8242C2.92578 12.9883 2.86198 13.1341 2.73438 13.2617C2.625 13.3711 2.48828 13.4258 2.32422 13.4258H1.75C1.58594 13.4258 1.44922 13.3711 1.33984 13.2617C1.23047 13.1341 1.17578 12.9883 1.17578 12.8242V11.7852C0.77474 11.4206 0.574219 10.9922 0.574219 10.5V4.67578C0.574219 3.74609 0.97526 3.1263 1.77734 2.81641C2.57943 2.48828 3.73698 2.32422 5.25 2.32422C5.32292 2.32422 5.44141 2.33333 5.60547 2.35156C5.76953 2.35156 5.88802 2.35156 5.96094 2.35156C6.30729 1.85938 6.79948 1.4401 7.4375 1.09375C8.09375 0.747396 8.72266 0.574219 9.32422 0.574219Z" fill="#292994"/>
                                        </svg>
                                    </li>
                                    <!-- <li :id="'button_vnr' + trip.item_id" v-if="trip.vnr == null" class="btn btn-vnr-white" @click="showModalEvento(trip)">VNR</li>
                                    <li :id="'button_vnr' + trip.item_id" v-if="trip.vnr != null" class="btn btn-vnr-black" @click="showModalEvento(trip)">VNR</li> -->
                                    <li class="custom-color-text-blue custom-list-painel" @click="menuContexto(trip)" >
                                        <span style="display: inline-block; padding: 5px;">Ao Vivo</span>
                                        <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M8.46995 9.66996L8.04995 9.23996C8.25662 9.0333 8.49328 8.87496 8.75995 8.76496C9.02662 8.65496 9.30662 8.59996 9.59995 8.59996C9.89328 8.59996 10.1742 8.65583 10.4426 8.76756C10.711 8.8793 10.9468 9.0401 11.15 9.24996L10.73 9.66996C10.58 9.51996 10.4074 9.4041 10.2124 9.32236C10.0173 9.24063 9.81315 9.19983 9.59995 9.19996C9.38662 9.19996 9.18242 9.24083 8.98735 9.32256C8.79228 9.4043 8.61982 9.5201 8.46995 9.66996ZM7.61995 8.81996L7.19995 8.39996C7.51662 8.07663 7.88248 7.8291 8.29755 7.65736C8.71262 7.48563 9.14675 7.39983 9.59995 7.39996C10.0533 7.39996 10.4875 7.48583 10.9026 7.65756C11.3176 7.8293 11.6834 8.07676 12 8.39996L11.58 8.81996C11.3166 8.55663 11.0141 8.3541 10.6724 8.21236C10.3306 8.07063 9.97315 7.99983 9.59995 7.99996C9.22662 7.99996 8.86908 8.07083 8.52735 8.21256C8.18562 8.3543 7.88315 8.55676 7.61995 8.81996ZM9.59995 10.8L8.89495 10.09C8.98828 9.99663 9.09582 9.92496 9.21755 9.87496C9.33928 9.82496 9.46675 9.79996 9.59995 9.79996C9.73328 9.79996 9.86082 9.82496 9.98255 9.87496C10.1043 9.92496 10.2118 9.99663 10.305 10.09L9.59995 10.8Z" fill="#292994"/>
                                            <path d="M6 9.6C6 8.28 6.72 7.14 7.8 6.48C7.74 6.18 7.5 6 7.2 6H3.6V4.8H4.8C5.16 4.8 5.4 4.56 5.4 4.2V3H6.6C7.26 3 7.8 2.46 7.8 1.8V1.56C9.54 2.28 10.8 3.96 10.8 6V6.18C11.22 6.3 11.58 6.54 11.94 6.84C12 6.6 12 6.3 12 6C12 2.7 9.3 0 6 0C2.7 0 0 2.7 0 6C0 9.3 2.7 12 6 12C6.3 12 6.6 12 6.84 11.94C6.3 11.28 6 10.5 6 9.6ZM5.4 10.74C3 10.44 1.2 8.46 1.2 6C1.2 5.64 1.26 5.28 1.32 4.92L4.2 7.8V8.4C4.2 9.06 4.74 9.6 5.4 9.6V10.74Z" fill="#292994"/>
                                        </svg>
                                    </li>
                                    <li class="custom-color-text-blue custom-list-painel" @click="modalReplay(trip)">
                                        <span style="display: inline-block; padding: 5px;">Replay</span>
                                        <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M6 9.6C6 8.28 6.72 7.14 7.8 6.48C7.74 6.18 7.5 6 7.2 6H3.6V4.8H4.8C5.16 4.8 5.4 4.56 5.4 4.2V3H6.6C7.26 3 7.8 2.46 7.8 1.8V1.56C9.54 2.28 10.8 3.96 10.8 6V6.18C11.22 6.3 11.58 6.54 11.94 6.84C12 6.6 12 6.3 12 6C12 2.7 9.3 0 6 0C2.7 0 0 2.7 0 6C0 9.3 2.7 12 6 12C6.3 12 6.6 12 6.84 11.94C6.3 11.28 6 10.5 6 9.6ZM5.4 10.74C3 10.44 1.2 8.46 1.2 6C1.2 5.64 1.26 5.28 1.32 4.92L4.2 7.8V8.4C4.2 9.06 4.74 9.6 5.4 9.6V10.74Z" fill="#292994"/>
                                            <path d="M9.59995 12C9.26662 12 8.95435 11.9389 8.66315 11.8166C8.37195 11.6944 8.11862 11.5295 7.90315 11.3219C7.68768 11.1139 7.51666 10.8697 7.39008 10.589C7.26351 10.3084 7.20013 10.0073 7.19995 9.68569H7.73328C7.73328 10.1871 7.91444 10.6125 8.27675 10.9619C8.63906 11.3113 9.08013 11.4859 9.59995 11.4857C10.12 11.4857 10.5611 11.311 10.9234 10.9616C11.2857 10.6123 11.4668 10.1869 11.4666 9.68569C11.4666 9.18426 11.2855 8.75886 10.9232 8.40949C10.5608 8.06012 10.1198 7.88552 9.59995 7.88569H9.55995L9.97328 8.28426L9.59995 8.65712L8.53328 7.62855L9.59995 6.59998L9.97328 6.97283L9.55995 7.3714H9.59995C9.93328 7.3714 10.2456 7.43252 10.5368 7.55475C10.828 7.67698 11.0813 7.84198 11.2968 8.04975C11.5122 8.25752 11.6833 8.5018 11.8101 8.7826C11.9368 9.0634 12.0001 9.36443 12 9.68569C12 10.0071 11.9366 10.3082 11.8098 10.589C11.6831 10.8698 11.512 11.1141 11.2968 11.3219C11.0811 11.5297 10.8278 11.6947 10.5368 11.8169C10.2457 11.9391 9.93346 12.0001 9.59995 12Z" fill="#292994"/>
                                        </svg>
                                    </li>
                                    <li class="custom-color-text-blue custom-list-painel">
                                        <span style="display: inline-block; padding: 5px;">Editar</span>
                                        <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M11.0859 3.10156L10.0195 4.16797L7.83203 1.98047L8.89844 0.914062C9.00781 0.804688 9.14453 0.75 9.30859 0.75C9.47266 0.75 9.60938 0.804688 9.71875 0.914062L11.0859 2.28125C11.1953 2.39062 11.25 2.52734 11.25 2.69141C11.25 2.85547 11.1953 2.99219 11.0859 3.10156ZM0.75 9.0625L7.20312 2.60938L9.39062 4.79688L2.9375 11.25H0.75V9.0625Z" fill="#292994"/>
                                        </svg>
                                    </li>
                                </ul>
                                </div>

                                <!-- <button :id="'button_vnr' + trip.item_id" v-if="trip.vnr == null" class="btn btn-vnr-white"
                                    @click="showModalEvento(trip)">VNR</button>
                                <button :id="'button_vnr' + trip.item_id" v-if="trip.vnr != null" class="btn btn-vnr-black"
                                    @click="showModalEvento(trip)">VNR</button> -->
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <div class="row div-rodape">
            <button class="btn panel-rodape" @click="showModalTerminal()">
                <svg width="24" height="24" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M22.0626 35.8438V39.875C24.0626 39.6875 25.9688 39.2188 27.7813 38.4688C29.5938 37.6563 31.2188 36.6563 32.6563 35.4688L29.8438 32.6563C28.7188 33.4688 27.5001 34.1563 26.1876 34.7188C24.8751 35.2813 23.5001 35.6563 22.0626 35.8438ZM4.06256 20C4.06256 17.3125 4.65631 14.8438 5.84381 12.5938C7.09381 10.2813 8.75006 8.37503 10.8126 6.87503C12.9376 5.37503 15.3126 4.46878 17.9376 4.15628V0.125031C15.4376 0.375031 13.0938 1.06253 10.9063 2.18753C8.78131 3.31253 6.87506 4.78128 5.18756 6.59378C3.56256 8.40628 2.28131 10.4688 1.34381 12.7813C0.468811 15.0313 0.031311 17.4375 0.031311 20C0.031311 22.5625 0.468811 25 1.34381 27.3125C2.28131 29.5625 3.56256 31.5938 5.18756 33.4063C6.87506 35.2188 8.78131 36.6875 10.9063 37.8125C13.0938 38.9375 15.4376 39.625 17.9376 39.875V35.8438C15.3126 35.5313 12.9376 34.625 10.8126 33.125C8.75006 31.625 7.09381 29.75 5.84381 27.5C4.65631 25.1875 4.06256 22.6875 4.06256 20ZM35.9376 18.0313H39.9688C39.7188 16.0313 39.2188 14.125 38.4688 12.3125C37.7188 10.5 36.7501 8.84378 35.5626 7.34378L32.6563 10.25C33.5313 11.3125 34.2501 12.5 34.8126 13.8125C35.3751 15.125 35.7501 16.5313 35.9376 18.0313ZM32.6563 4.53128C31.2188 3.34378 29.5938 2.37503 27.7813 1.62503C25.9688 0.812531 24.0626 0.312531 22.0626 0.125031V4.15628C23.5001 4.34378 24.8751 4.71878 26.1876 5.28128C27.5001 5.84378 28.7188 6.53128 29.8438 7.34378L32.6563 4.53128ZM32.6563 29.8438L35.5626 32.6563C36.7501 31.1563 37.7188 29.5 38.4688 27.6875C39.2188 25.875 39.7188 23.9688 39.9688 21.9688H35.9376C35.7501 23.4688 35.3751 24.875 34.8126 26.1875C34.2501 27.5 33.5313 28.7188 32.6563 29.8438ZM27.9688 18.2188C27.9688 16.5313 27.5938 15.0938 26.8438 13.9063C26.0938 12.6563 25.0938 11.6875 23.8438 11C22.6563 10.3125 21.3751 9.96878 20.0001 9.96878C18.6251 9.96878 17.3126 10.3125 16.0626 11C14.8751 11.6875 13.9063 12.6563 13.1563 13.9063C12.4063 15.0938 12.0313 16.5313 12.0313 18.2188C12.0313 21.5313 14.6876 25.4688 20.0001 30.0313C25.3126 25.4688 27.9688 21.5313 27.9688 18.2188ZM20.0001 20C19.4376 20 18.9376 19.8125 18.5001 19.4375C18.0626 19 17.8438 18.4688 17.8438 17.8438C17.8438 17.2813 18.0626 16.7813 18.5001 16.3438C18.9376 15.9063 19.4376 15.6875 20.0001 15.6875C20.5626 15.6875 21.0626 15.9063 21.5001 16.3438C21.9376 16.7813 22.1563 17.2813 22.1563 17.8438C22.1563 18.4688 21.9376 19 21.5001 19.4375C21.0626 19.8125 20.5626 20 20.0001 20Z"
                        fill="#E4EBF3" />
                </svg>
                Terminal
            </button>
            <button class="btn panel-rodape btnblue" @click="showModalGarage()">
                <svg width="24" height="24" viewBox="0 0 34 38" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M29 18.0313V8.00003H5.00003V18.0313H29ZM23.8438 29.1875C24.4063 29.75 25.125 30.0313 26 30.0313C26.875 30.0313 27.5938 29.75 28.1563 29.1875C28.7188 28.5625 29 27.8438 29 27.0313C29 26.2188 28.7188 25.5313 28.1563 24.9688C27.5938 24.3438 26.875 24.0313 26 24.0313C25.125 24.0313 24.4063 24.3438 23.8438 24.9688C23.2813 25.5313 23 26.2188 23 27.0313C23 27.8438 23.2813 28.5625 23.8438 29.1875ZM5.84378 29.1875C6.40628 29.75 7.12503 30.0313 8.00003 30.0313C8.87503 30.0313 9.59378 29.75 10.1563 29.1875C10.7188 28.5625 11 27.8438 11 27.0313C11 26.2188 10.7188 25.5313 10.1563 24.9688C9.59378 24.3438 8.87503 24.0313 8.00003 24.0313C7.12503 24.0313 6.40628 24.3438 5.84378 24.9688C5.28128 25.5313 5.00003 26.2188 5.00003 27.0313C5.00003 27.8438 5.28128 28.5625 5.84378 29.1875ZM0.968781 27.9688V8.00003C0.968781 4.81253 2.34378 2.68753 5.09378 1.62503C7.84378 0.562531 11.8125 0.0312805 17 0.0312805C22.1875 0.0312805 26.1563 0.562531 28.9063 1.62503C31.6563 2.68753 33.0313 4.81253 33.0313 8.00003V27.9688C33.0313 29.7188 32.3438 31.2188 30.9688 32.4688V36.0313C30.9688 36.5938 30.7813 37.0625 30.4063 37.4375C30.0313 37.8125 29.5625 38 29 38H27.0313C26.4688 38 25.9688 37.8125 25.5313 37.4375C25.1563 37.0625 24.9688 36.5938 24.9688 36.0313V33.9688H9.03128V36.0313C9.03128 36.5938 8.81253 37.0625 8.37503 37.4375C8.00003 37.8125 7.53128 38 6.96878 38H5.00003C4.43753 38 3.96878 37.8125 3.59378 37.4375C3.21878 37.0625 3.03128 36.5938 3.03128 36.0313V32.4688C1.65628 31.2188 0.968781 29.7188 0.968781 27.9688Z"
                        fill="#E4EBF3" />
                </svg>
                Garagem
            </button>
            <button class="btn panel-rodape btnblue" @click="ShowModalForaDeEscala()">
                <svg width="24" height="24" viewBox="0 0 45 46" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M29 18.9688H33.0313V23H29V18.9688ZM29 6.96878H33.0313V17H29V6.96878ZM23.9375 22.0625C25.875 24 28.2188 24.9688 30.9688 24.9688C33.7188 24.9688 36.0625 24 38 22.0625C40 20.125 41 17.7813 41 15.0313C41 12.2813 40 9.93753 38 8.00003C36.0625 6.00003 33.7188 5.00003 30.9688 5.00003C28.2188 5.00003 25.875 6.00003 23.9375 8.00003C22 9.93753 21.0313 12.2813 21.0313 15.0313C21.0313 17.7813 22 20.125 23.9375 22.0625ZM23.8438 36.125C24.4063 36.6875 25.125 36.9688 26 36.9688C26.875 36.9688 27.5938 36.6875 28.1563 36.125C28.7188 35.5 29 34.7813 29 33.9688C29 33.1563 28.7188 32.4688 28.1563 31.9063C27.5938 31.2813 26.875 30.9688 26 30.9688C25.125 30.9688 24.4063 31.2813 23.8438 31.9063C23.2813 32.4688 23 33.1563 23 33.9688C23 34.7813 23.2813 35.5 23.8438 36.125ZM5.00003 24.9688H21.2188C18.4063 22.2813 17 18.9688 17 15.0313H5.00003V24.9688ZM5.84378 36.125C6.40628 36.6875 7.12503 36.9688 8.00003 36.9688C8.87503 36.9688 9.59378 36.6875 10.1563 36.125C10.7188 35.5 11 34.7813 11 33.9688C11 33.1563 10.7188 32.4688 10.1563 31.9063C9.59378 31.2813 8.87503 30.9688 8.00003 30.9688C7.12503 30.9688 6.40628 31.2813 5.84378 31.9063C5.28128 32.4688 5.00003 33.1563 5.00003 33.9688C5.00003 34.7813 5.28128 35.5 5.84378 36.125ZM30.9688 0.968781C34.8438 1.03128 38.125 2.43753 40.8125 5.18753C43.5625 7.93753 44.9375 11.2188 44.9375 15.0313C44.9375 18.3438 43.7813 21.3438 41.4688 24.0313C39.1563 26.7188 36.3438 28.3125 33.0313 28.8125V35C33.0313 36.6875 32.3438 38.1563 30.9688 39.4063V42.9688C30.9688 43.5313 30.7813 44.0313 30.4063 44.4688C30.0313 44.8438 29.5625 45.0313 29 45.0313H27.0313C26.4688 45.0313 25.9688 44.8438 25.5313 44.4688C25.1563 44.0313 24.9688 43.5313 24.9688 42.9688V41H9.03128V42.9688C9.03128 43.5313 8.81253 44.0313 8.37503 44.4688C8.00003 44.8438 7.53128 45.0313 6.96878 45.0313H5.00003C4.43753 45.0313 3.96878 44.8438 3.59378 44.4688C3.21878 44.0313 3.03128 43.5313 3.03128 42.9688V39.4063C1.65628 38.1563 0.968781 36.6875 0.968781 35V15.0313C0.968781 11.8438 2.34378 9.71878 5.09378 8.65628C7.84378 7.53128 11.8125 6.96878 17 6.96878C17.25 6.96878 17.6563 7.00003 18.2188 7.06253C18.7813 7.06253 19.1875 7.06253 19.4375 7.06253C20.625 5.37503 22.3125 3.93753 24.5 2.75003C26.75 1.56253 28.9063 0.968781 30.9688 0.968781Z"
                        fill="#E4EBF3" />
                </svg>
                Fora de Escala
            </button>
        </div>

        
    </div>
</template>

<script>
import './../../assets/css/operacoes/panel.css';
import http from '../../services/http.js';

import socket from '../../services/socket-client.js';

export default {
    name: 'Palco',
    mixins: [
        socket
    ],
    data: () => {
        return {
            user: {
                email: null,
                id: null,
                group_id: null
            },
            group_id: [],
            id_empresa: null,
            grouplines: [],
            terminals: [],
            lines: [],
            senses: [],
            positions: [],
            vehicles: [],
            trips: [],
            newTrips: [],
            selectedGroup: null,
            selectedTerminal: null,
            selectedLine: null,
            selectedSense: null,
            selectedPosition: null,
            selectedVehicle: null,
            typeTrips: null, // dado enviado do checkbox top
            assets: [],
            drivers: [],
            change_list: [],
            controlFormatTrips: true,
            checkDayTrips: false,
            checkFilters: false,
            formater: null,
            date: moment().format('YYYY-MM-DD'),
            clearUrl: null,
            filterColumns: [],
            colors: {
                verde: "#028D4D",
                amarelo: "#C8A21E",
                vermelho: "#D0404B",
                cinza: "#BCBCBC",
            },
            position: [],
            filterPolylines: [],
            center: { lat: 0, lng: 0 },
            sentido_itinerario: null,
            itinerario_ida: [],
            itinerario_volta: [],
            itinerarios: []
        }
    },
    mounted() {

        // var expressToken = new URLSearchParams(window.location.search)
        var Token = window.location.search.substr(1);
        if (Token != '') {
            // console.log("Found token: " + Token);
            var result = Token.split("&");

            var expressToken = result[0];
            expressToken = expressToken.replace('token=', '');
            localStorage.setItem("token", expressToken);

            var expressCompany = result[1];
            expressCompany = expressCompany.replace('empresa=', '');
            localStorage.setItem("empresa", expressCompany);

            // console.log(expressCompany)

            this.emitter.emit('ExpressCompany', expressCompany);


            this.clearUrl = setInterval(() => {
                // console.log("teste")
                if (localStorage.getItem('token') == expressToken && localStorage.getItem('empresa') == expressCompany) {
                    // window.location.href = 'http://localhost:8080/operacoes';
                    window.location.href = 'https://telaoperacoes.azurewebsites.net/operacoes';
                }
            }, 2000);


        }

        this.emitter.on('changeClassPanelTrip', data => {
            // console.log('changeClassPanelTrip', data);
            this.trips.forEach(e => {
                if (e.item_id == data) e.class = 'compromised';
            });
        })

        this.emitter.on('dataUser', data => {
            this.user = data;
        })

        this.emitter.on('changeOfDate', data => {
            // console.log("teste in data" , data)
            this.date = data;
            this.dayTrips();
            // this.updateApplication();
        })
        this.emitter.on('changeOfRangeTime', data => {
            // console.log("changeOfRangeTime")
            this.rangetime = data;
            this.dayTrips();
            // this.updateApplication();    
        })

        this.emitter.on('changeOfCompany', data => {
            this.id_empresa = data;
            // this.dayTrips(); 

            this.updateApplication();

            // CARREGAMENTO DE MÉTODOS COM A TELA
            // this.filters(); // DESABILITAR COM O USO DO SOCKET, HABITAR SEM O USO DO SOCKET
        })

        // updateTrips after saved
        this.emitter.on('updateTrips', data => {
            console.log("received: ", data);
            this.updateRows(data[0], data[1]);
        })

        // filter of the checkbox top
        this.emitter.on('filterTypeTrips', data => {
            this.typeTrips = data;
            this.dayTrips();
            // this.updateApplication();
        })

        this.emitter.on('atualizaEvento', data => {
            var objectEvento = data;

            if (objectEvento.status == null) {
                $('#' + objectEvento.id).addClass("vnr");
                $('#button_vnr' + objectEvento.id).addClass("button-vnr-active");
            } else {
                $('#' + objectEvento.id).removeClass("vnr");
                $('#button_vnr' + objectEvento.id).removeClass("button-vnr-active");
                $('#' + objectEvento.id).addClass(objectEvento.class);
                // console.log(objectEvento)
            }

        })

        this.emitter.on('socketDayTrips', data => {
            console.log("socketDayTrips received", moment().format('DD/MM/YYYY HH:mm:ss'))

            // configurações para dayTrips
            this.trips = data

            this.checkDayTrips = true;
            this.controlFormatTrips = true;
            this.formater = setInterval(this.controlFormatTable, 2000);
        })

        this.emitter.on('socketFilters', data => {
            console.log("socketFilters received", moment().format('DD/MM/YYYY HH:mm:ss'))
            // confirguraçoes para filters
            this.checkFilters = true;
            this.grouplines = data.groupline;
            this.terminals = data.terminals;
            this.lines = data.lines;
            this.senses = data.senses;
            this.positions = data.positions;
            this.vehicles = data.vehicles;
            this.drivers = data.drivers;
        })

        // this.emitter.on('actionTotals', data => {
        //     this.dayTrips();
        // })

        this.emitter.on("updateIncluirViagem", (data) => {
            this.updateIncluirViagem(data);
        })

        this.emitter.on('socketFiltersColumns', (data) => {
            this.filterColumns = data;
        })


    },
    methods: {
        clearUrl() {
            clearInterval(this.clearUrl);
        },
        updateApplication() {
            console.log("updateApplication", this.rangetime)
            var params = {
                date: this.date,
                orgid: this.id_empresa,
                rangetime: this.rangetime != null ? this.rangetime : 30,
                line_group: this.selectedGroup != null ? this.selectedGroup : '',
                terminal: this.selectedTerminal != null || this.selectedTerminal != 'null' ? this.selectedTerminal : '',
                line: this.selectedLine != null || this.selectedLine != 'null' ? this.selectedLine : '',
                sense: this.selectedSense != null || this.selectedSense != 'null' ? this.selectedSense : '',
                position: this.selectedPosition != null || this.selectedPosition != 'null' ? this.selectedPosition : '',
                vehicle: this.selectedVehicle != null || this.selectedVehicle != 'null' ? this.selectedVehicle : '',
                type: this.typeTrips != null || this.typeTrips != 'null' ? this.typeTrips : '',
            };

            this.getData(params)
        },
        controlFormatTable() {
            // console.log("step 1", this.checkDayTrips && this.checkFilters && this.controlFormatTrips, this.checkDayTrips , this.checkFilters , this.controlFormatTrips)            
            if (this.checkDayTrips && this.checkFilters && this.controlFormatTrips) {
                this.formatTrips();
            }
            if (!this.controlFormatTrips) {
                clearInterval(this.formater);
            }
        },
        dayTrips() {
            console.log("1 - ", this.selectedLine != null, this.selectedLine != 'null')
            var params = {
                date: this.date,
                orgid: this.id_empresa,
                rangetime: this.rangetime != null ? this.rangetime : 30,
                line_group: this.selectedGroup != null ? (this.selectedGroup != 'null' ? this.selectedGroup : null) : null, //this.selectedGroup : null, 
                terminal: this.selectedTerminal != null ? (this.selectedTerminal != 'null' ? this.selectedTerminal : null) : null, //|| this.selectedTerminal != 'null' ? this.selectedTerminal : null, 
                line: this.selectedLine != null ? (this.selectedLine != 'null' ? this.selectedLine : null) : null, //this.selectedLine != 'null' ? this.selectedLine : null, 
                // line : this.selectedLine != null || this.selectedLine != 'null' ? this.selectedLine : null, 
                sense: this.selectedSense != null ? (this.selectedSense != 'null' ? this.selectedSense : null) : null, //|| this.selectedSense != 'null' ? this.selectedSense : null, 
                position: this.selectedPosition != null ? (this.selectedPosition != 'null' ? this.selectedPosition : null) : null, //|| this.selectedPosition != 'null' ? this.selectedPosition : null,  
                vehicle: this.selectedVehicle != null ? (this.selectedVehicle != 'null' ? this.selectedVehicle : null) : null, //|| this.selectedVehicle != 'null' ? this.selectedVehicle : null,                                                
                type: this.typeTrips != null ? (this.typeTrips != 'null' ? this.typeTrips : null) : null, //|| this.typeTrips != 'null' ? this.typeTrips : null,                                                
            };
            this.updateObject(params);
            this.emitter.emit('newTotais', params);

            var objectEvents = {
                evento: null,
                tipo: null,
                veiculo: this.selectedVehicle != null ? (this.selectedVehicle != 'null' ? this.selectedVehicle : null) : null,
                linha: this.selectedLine != null ? (this.selectedLine != 'null' ? this.selectedLine : null) : null,
                motorista: null,
            };

            this.emitter.emit('filtrosEventos', objectEvents);

            http.get('/operation/day_trips', { params })
                .then(res => {
                    this.trips = res.data;

                    this.checkDayTrips = true;
                    this.controlFormatTrips = true;
                    this.formater = setInterval(this.controlFormatTable, 2000);
                }).catch(err => console.log(err));
        },
        filters() {
            http.get('/operation/filters', {
                params: {
                    orgid: this.id_empresa,
                    // group_id: this.user.group_id
                }
            }).then(res => {
                this.grouplines = res.data.groupline;
                this.terminals = res.data.terminals;
                this.lines = res.data.lines;
                this.senses = res.data.senses;
                this.positions = res.data.positions;
                this.vehicles = res.data.vehicles;
                this.drivers = res.data.drivers;
                this.checkFilters = true;
            }).catch(err => console.log(err));

        },
        selectedFilter(event, tipo) {
            this.dayTrips();

            // var params = {    
            //     date: this.date,
            //     orgid: this.id_empresa,             
            //     rangetime : this.rangetime != null ? this.rangetime : 30,
            //     line_group : this.selectedGroup != null ? this.selectedGroup : '', 
            //     terminal : this.selectedTerminal != null || this.selectedTerminal != 'null' ? this.selectedTerminal : '', 
            //     line : this.selectedLine != null || this.selectedLine != 'null' ? this.selectedLine : '', 
            //     sense : this.selectedSense != null || this.selectedSense != 'null' ? this.selectedSense : '', 
            //     position : this.selectedPosition != null || this.selectedPosition != 'null' ? this.selectedPosition : '',  
            //     vehicle : this.selectedVehicle != null || this.selectedVehicle != 'null' ? this.selectedVehicle : '',                                                
            //     type : this.typeTrips != null || this.typeTrips != 'null' ? this.typeTrips : ''                                            
            // };

            // this.updateApplication();

            // this.emitter.emit('newTotais', params);
        },
        updateTrips(item_id, id_quadro_horario, viagem, posicao, data, value, start_time, data_trip, sense_name, line) {
            var asset_id = null;
            var registration_number = this.change_list['input_asset_' + item_id];
            if (registration_number != null) {
                this.vehicles.forEach(e => {
                    if (registration_number.alias == e.alias) asset_id = e.id
                    if (registration_number == e.alias) asset_id = e.id
                });
            }

            var driver_id = null;
            var employee_number_driver = this.change_list['input_driver_' + item_id];
            if (employee_number_driver != null) {
                this.drivers.forEach(e => {
                    if (employee_number_driver.alias == e.alias) driver_id = e.id
                    if (employee_number_driver == e.alias) driver_id = e.id
                });
            }

            var nodriver_id = null;
            var employee_number_nodriver = this.change_list['input_cobrador_' + item_id];
            if (employee_number_nodriver != null) {
                this.drivers.forEach(e => {
                    if (employee_number_nodriver == e.alias && e.tipo == 'cobrador') nodriver_id = e.id
                    if (employee_number_nodriver == e.alias) nodriver_id = e.id
                });
            }

            var old_asset_id = null;
            if (asset_id == null) {
                this.trips.forEach(e => {
                    if (item_id == e.item_id) old_asset_id = e.old_asset_id;
                });

                if (old_asset_id != null) {
                    this.vehicles.forEach(e => {
                        if (e.alias == old_asset_id) old_asset_id = e.id;
                    })
                }
            }

            var data = {
                id_empresa: this.id_empresa,
                id_quadro_horario_item: item_id,
                number_trip: viagem,
                sense_name: sense_name,
                line_id: line,
                position: posicao,
                data: data,
                asset_id: asset_id != null ? asset_id : '',
                old_asset_id: old_asset_id,
                employee_number_driver: driver_id != null ? driver_id : '',
                employee_number_nodriver: nodriver_id != null ? nodriver_id : '',
                start_time: start_time,
                data: data_trip
            }

            // console.log('update trip', data, this.change_list['input_asset_'+item_id]);

            this.showModalReplicarConfirm(data);

        },
        replicarSave(asset_id, driver_id, nodriver_id, start_time, data_trip) {
            var data = {
                id_empresa: this.id_empresa,
                asset_id: asset_id,
                driver_id: driver_id,
                cobrador_id: nodriver_id,
                start_time: start_time,
                data: data_trip
            };

            http.post('operation/replicar/update/trips', data)
                .then(res => {
                    if (res.data.status) {
                        this.$swal('Replicar salvo com sucesso.');
                        var update_trips = res.data.dados;
                        this.updateRows(update_trips);
                    } else this.$swal('Não foi possível replicar o salvamento.');
                }).catch(err => console.log(err));
        },
        updateRows(update_trips, processar) { //método usado para atualizar as linhas da tabela
            console.log('update_trips: ', update_trips, processar)
            for (var i = 0; i < update_trips.length; i++) {
                this.trips.forEach(e => {
                    if (update_trips[i]['item_id'] == e.item_id) {
                        if (processar) {
                            e.real_time_end = null;
                            e.real_time_start = null;
                        }

                        this.vehicles.forEach(v => {
                            if (v.id == update_trips[i]['asset_id']) {
                                e.asset_id = v.alias;
                                this.change_list['input_asset_' + e.item_id] = v.alias;
                            }
                            if (v.id == update_trips[i]['old_asset_id']) e.old_asset_id = v.alias;
                        })

                        this.drivers.forEach(d => {
                            if (d.id == update_trips[i]['driver_id']) {
                                e.driver_id = d.alias;
                                this.change_list['input_driver_' + e.item_id] = d.alias;
                            }
                            if (d.id == update_trips[i]['old_driver_id']) e.old_driver_id = d.alias;
                        })

                        this.drivers.forEach(d => {
                            // if (d.id == update_trips[i]['cobrador_id']) e.cobrador_id = d.alias;
                            // if (d.id == update_trips[i]['old_cobrador_id']) e.old_cobrador_id = d.alias;
                            if (d.id == update_trips[i]['cobrador_id']) {
                                e.driver_id = d.alias;
                                this.change_list['input_cobrador_' + e.item_id] = d.alias;
                            }
                            if (d.id == update_trips[i]['old_nodriver_id']) e.old_driver_id = d.alias;
                        })

                        var asset_id = update_trips[i]['asset_id'] != null ? update_trips[i]['asset_id'] : null;
                        if (asset_id == null) {
                            this.change_list['input_asset_' + e.item_id] = null;
                            e.asset_id = null;
                        }

                        // console.log("asset", update_trips[i]['asset_id'], e.asset_id)

                        var driver_id = update_trips[i]['driver_id'] != null ? update_trips[i]['driver_id'] : null;
                        if (driver_id == null) {
                            e.driver_id = null;
                            this.change_list['input_driver_' + e.item_id] = null;
                        }

                        // console.log("motorista", update_trips[i]['driver_id'], e.driver_id)

                        var cobrador_id = update_trips[i]['cobrador_id'] != null ? update_trips[i]['cobrador_id'] : null;
                        if (cobrador_id == null) e.cobrador_id = null;

                        var old_asset_id = update_trips[i]['old_asset_id'] != null ? update_trips[i]['old_asset_id'] : null;
                        if (old_asset_id == null) e.old_asset_id = null;

                        var old_driver_id = update_trips[i]['old_driver_id'] != null ? update_trips[i]['old_driver_id'] : null;
                        if (old_driver_id == null) e.old_driver_id = null;

                        var old_cobrador_id = update_trips[i]['old_cobrador_id'] != null ? update_trips[i]['old_cobrador_id'] : null;
                        if (old_cobrador_id == null) e.old_cobrador_id = null;

                        // INSERT CLASS FOR BOLD
                        if (asset_id != old_asset_id) $('#asset' + e.item_id).addClass('bold-text');
                        else $('#asset' + e.item_id).removeClass('bold-text');

                        if (driver_id != old_driver_id) $('#driver' + e.item_id).addClass('bold-text');
                        else $('#driver' + e.item_id).removeClass('bold-text');

                        if (cobrador_id != old_cobrador_id) $('#cobrador' + e.item_id).addClass('bold-text');
                        else $('#cobrador' + e.item_id).removeClass('bold-text');


                    }
                });
            }
        },
        showModalGarage() {
            if (this.id_empresa != null) this.emitter.emit('garagem');
        },
        ShowModalForaDeEscala() {
            if (this.id_empresa != null) this.emitter.emit('foraescala', this.id_empresa);
        },
        showModalTerminal() {
            var objectTerminal = {
                orgid: this.id_empresa,
            };
            this.emitter.emit('terminal', objectTerminal);
        },
        showModalReplicarConfirm(data) {
            if (this.id_empresa != null) this.emitter.emit('replicarConfirm', data);
        },

        // showModalReplicarList() {
        //     var data = ''
        //     this.emitter.emit('replicarList', data); 
        // },
        showModalFiltro() {
            var data = ''
            $('#filtro').modal('show');
        },
        changeClass(id, tipo) {
            $('#' + tipo + id).children('span').addClass("open");
        },
        formatTrips() {
            if (this.filterColumns.length > 0) { this.emitter.emit('FiltersColumns', this.filterColumns); };
            this.trips.forEach(e => {
                console.log("check")
                var registration_number = null;
                this.vehicles.forEach(k => {
                    if (e.asset_id == k.id) registration_number = k.alias
                    if (e.old_asset_id == k.id) e.old_asset_id = k.alias
                });

                var employee_number_driver = null;
                this.drivers.forEach(d => {
                    if (d.id == e.driver_id) employee_number_driver = d.alias;
                    if (d.id == e.old_driver_id) e.old_driver_id = d.alias;
                });

                var employee_number_nodriver = null;
                this.drivers.forEach(d => {
                    if (d.tipo == 'cobrador') {
                        if (d.id == e.cobrador_id) employee_number_nodriver = d.alias;
                        if (d.id == e.old_cobrador_id) e.old_cobrador_id = d.alias;
                    }
                });

                // console.log("registration_number", registration_number)
                this.change_list['input_asset_' + e.item_id] = registration_number;
                this.change_list['input_driver_' + e.item_id] = employee_number_driver;
                this.change_list['input_cobrador_' + e.item_id] = employee_number_nodriver;

                e.old_asset_id = e.old_asset_id != null ? e.old_asset_id : registration_number;
                e.old_driver_id = e.old_driver_id != null ? e.old_driver_id : employee_number_driver;
                e.old_cobrador_id = e.old_cobrador_id != null ? e.old_cobrador_id : employee_number_nodriver;

                // INSERT CLASS FOR BOLD
                if (registration_number != e.old_asset_id) $('#asset' + e.item_id).addClass('bold-text');
                else $('#asset' + e.item_id).removeClass('bold-text');

                if (employee_number_driver != e.old_driver_id) $('#driver' + e.item_id).addClass('bold-text');
                else $('#driver' + e.item_id).removeClass('bold-text');

                if (employee_number_nodriver != e.old_cobrador_id) $('#cobrador' + e.item_id).addClass('bold-text');
                else $('#cobrador' + e.item_id).removeClass('bold-text');

            })
            this.controlFormatTrips = false;
            // this.checkFilters = false;
            this.checkDayTrips = false;

            // this.updateClassCompromised();
        },
        showModalEvento(trip) {

            var objectEvento = {
                registration_number: this.change_list['input_asset_' + trip.item_id],
                employee_number_driver: this.change_list['input_driver_' + trip.item_id],
                employee_number_cobrador: this.change_list['input_cobrador_' + trip.item_id],
                itinerario: trip.route_name,
                posicao: trip.position,
                linha: trip.line_code,
                viagem: trip.number_trip,
                saida_prevista: trip.expected_time_start,
                item_id: trip.item_id,
                sentidos: this.senses,
                id_empresa: this.id_empresa,
                sentido_default: trip.sense_name,
                viagem: trip.number_trip,
                data: trip.data,
                posicao: trip.position,
                quadro_horario_id: trip.plannning_id,
                assetId: trip.asset_id,
                driverid: trip.driver_id,
                linhaId: trip.line_id,
                emailUser: this.user.email
            }
            this.emitter.emit('adicionarEvento', objectEvento);
        },
        showModalIncluirViagem() {
            var objectViagem = {
                date: this.date,
                // date: this.dataFromSidebar,
                id_empresa: this.id_empresa,
                drivers: this.drivers,
                vehicles: this.vehicles
            }
            this.emitter.emit('incluirViagem', objectViagem);
        },
        getIdItem(numero) { console.log(numero) },
        updateIncluirViagem(res) {

            this.trips = res

            this.formatTrips();
        },
        showModalFiltroLinhas() {
            var object = {
                orgid: this.id_empresa,
                data: this.date
            };
            this.emitter.emit('filtroLinhas', object);
        },
        showModalNovaEscala() {
            var object = {
                orgid: this.id_empresa,
                // data: this.date
            };
            this.emitter.emit('openNovaEscala', object);
        },
        menuContexto(trip) {

            http.get('aovivo/itinerary/map', {
                params: {
                    orgid: this.id_empresa,
                    data: this.date,
                    linha_id: trip.line_id,
                    item_id: trip.item_id,
                    itinerario_id: trip.route_id,
                    asset_id: trip.asset_id
                }
            }).then(response => {
                // console.log('itinerario: ',  response)

                this.itinerarios = response.data.itinerario;

                this.position = response.data.position;
                this.center.lat = parseFloat(this.position.Latitude);
                this.center.lng = parseFloat(this.position.Longitude);


                this.emitter.emit('menuContexto', [this.id_empresa, trip,  this.center, this.date, this.position, this.sentido_itinerario, this.itinerarios]);
                // this.emitter.emit('menuContexto', [this.id_empresa, trip, this.filterPolylines, this.center, this.date, this.position, this.sentido_itinerario]);

            }).catch(error => console.log(error));
        },
        modalReplay(trip) {
            // var object = {
            //     orgid: this.id_empresa,
            //     // data: this.date
            // };
            // this.emitter.emit('modalReplay', object);

            http.get('aovivo/itinerary/map', {
                params: {
                    orgid: this.id_empresa,
                    data: this.date,
                    linha_id: trip.line_id,
                    item_id: trip.item_id,
                    itinerario_id: trip.route_id,
                    asset_id: trip.asset_id
                }
            }).then(response => {
                this.itinerarios = response.data.itinerario;

                this.itinerarios.forEach(item => {

                    if (item.sentido == 'i') {
                        var polyline = item.polyline;
                        polyline.forEach(e => {
                            this.itinerario_ida.push({ lat: parseFloat(e.lat), lng: parseFloat(e.lng) });
                        })
                    }

                    if (item.sentido == 'v') {
                        var polyline = item.polyline;
                        polyline.forEach(e => {
                            this.itinerario_volta.push({ lat: parseFloat(e.lat), lng: parseFloat(e.lng) });
                        })
                    }
                });

                this.position = response.data.position;
                this.center.lat = parseFloat(this.position.Latitude);
                this.center.lng = parseFloat(this.position.Longitude);


                this.emitter.emit('replay', [this.id_empresa, trip, this.itinerario_ida, this.itinerario_volta, this.center, this.date, this.position, this.sentido_itinerario]);
                // this.emitter.emit('menuContexto', [this.id_empresa, trip, this.filterPolylines, this.center, this.date, this.position, this.sentido_itinerario]);

            }).catch(error => console.log(error));
        }
    },
}
</script>

<!-- <style scoped>

    .custom-padding {
        padding: 10px;
    }

</style> -->